// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-product';

export const resetPipProduct = () => ({
    data: getDefaultState(),
    type: actions.RESET_PIP_CODE_REQUEST_PIP_PRODUCT

});



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/reset-pip-product.js